<template>
  <div class="upload-tray" v-if="visible">
    <div class="upload-tray-header" v-on:click="collapsed = !collapsed">
      <i :class="'fa fa-fw ' + (active.length ? 'fa-cloud-arrow-up' : 'fa-image')"></i>
      <span class="upload-tray-title">{{ title }}</span>
      <i :class="'fa fa-fw ' + (collapsed ? 'fa-chevron-up' : 'fa-chevron-down')"></i>
    </div>
    <div class="upload-tray-body" v-if="!collapsed">
      <upload-progress :uploads="listed" />
      <div class="upload-tray-pending" v-for="group in pendingGroups" :key="group.owner">
        <div class="upload-tray-pending-text">{{ pendingText(group) }}</div>
        <div class="upload-tray-pending-actions">
          <button type="button" class="btn btn-xs btn-primary" v-if="group.open" v-on:click="open(group)">{{ _('Open') }}</button>
          <button type="button" class="btn btn-xs btn-default" v-on:click="discard(group)">{{ _('Discard') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { dismiss } from '~/lib/uploadqueue'

// Background uploads of the current shop: progress of running uploads and
// images that wait for their editor to be opened (see lib/uploadqueue.js)
export default {
  data () {
    return {
      collapsed: false
    }
  },
  computed: {
    ...mapGetters(['shopId', 'uploads']),
    shopUploads () {
      return this.uploads.filter(u => u.shopId === this.shopId)
    },
    active () {
      return this.shopUploads.filter(u => ['queued', 'fetching', 'uploading', 'processing'].includes(u.status))
    },
    listed () {
      return this.shopUploads.filter(u => u.status !== 'done')
    },
    pendingGroups () {
      const groups = {}
      for (const upload of this.shopUploads) {
        if (upload.status !== 'done' || !upload.owner || upload.applied) {
          continue
        }
        if (!groups[upload.owner]) {
          groups[upload.owner] = { owner: upload.owner, label: upload.ownerLabel, open: upload.open, ids: [] }
        }
        groups[upload.owner].ids.push(upload.id)
      }
      return Object.values(groups)
    },
    visible () {
      return this.listed.length > 0 || this.pendingGroups.length > 0
    },
    title () {
      if (this.active.length) {
        return this.active.length === 1 ? this._('Uploading 1 image') : this._('Uploading %d images').replace('%d', this.active.length)
      }
      return this._('Images')
    }
  },
  methods: {
    pendingText (group) {
      const count = group.ids.length
      const text = count === 1 ? this._('1 image is waiting to be added to %s') : this._('%d images are waiting to be added to %s').replace('%d', count)
      return text.replace('%s', group.label || this._('an unsaved item'))
    },
    open (group) {
      this.EventBus.$emit('showDetailsColumn', { ...group.open, shopId: this.shopId })
    },
    discard (group) {
      // The images stay in the shop's files, they are just not added to the item
      for (const id of group.ids) {
        dismiss(id)
      }
    }
  }
}
</script>

<style scoped>
.upload-tray {
  position: fixed;
  left: 16px;
  bottom: 16px;
  width: 320px;
  max-width: calc(100vw - 32px);
  z-index: 1040;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}
.upload-tray-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  cursor: pointer;
  font-weight: bold;
}
.upload-tray-title {
  flex: 1;
}
.upload-tray-body {
  max-height: 40vh;
  overflow-y: auto;
  padding: 0 10px 10px;
}
.upload-tray-pending {
  border-top: 1px solid #eee;
  padding-top: 6px;
  margin-top: 6px;
  font-size: 12px;
}
.upload-tray-pending-actions {
  display: flex;
  gap: 6px;
  margin-top: 4px;
}
</style>
